import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, of, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { StorageService } from 'app/core/auth/storage.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(
        private _httpClient: HttpClient,
        private storage: StorageService
    ) {}

    // Setter & getter for user
    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Get the current logged in user data (dari localStorage, encrypted)
     */
    get(): Observable<User> {
        const userEnc = localStorage.getItem('user');

        try {
            if (userEnc) {
                const decrypted = this.storage.decryptionAES(userEnc);
                const user: User = JSON.parse(decrypted);
                this._user.next(user);
                return of(user);
            }
        } catch (e) {
            console.warn('Failed to decrypt/parse user from localStorage', e);
        }

        // No user found → return null (will be handled by AuthGuard)
        return of(null);
    }

    /**
     * Update the user
     */
    update(user: User): Observable<any> {
        // Mock update
        this._user.next(user);
        return of(user);
        
        /*
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
                localStorage.setItem('user', JSON.stringify(response));
            })
        );
        */
    }
}
